define('core/views/SoundCloudRichMediaView',[
    'core/views/AutoplayRichMediaView',
], function (
    AutoplayRichMediaView
) {
    'use strict';

    return AutoplayRichMediaView.extend({
        // Force full-width media dimensions.

        getMediaDimensions: function () {
            // The SoundCloud player automatically changes its layout for
            // different widths, but the height must be as provided; we should
            // not attempt to scale it to fit the embed.
            return {
                width: null,
                height: this.media.get('htmlHeight'),
            };
        },
    });
});

